import React from "react"
import { graphql } from "gatsby"
import IntroSummary from "../components/organisms/IntroSummary"
import Sidebar from "./../components/organisms/Sidebar"
import ContentSummary from "../components/atoms/ContentSummary"
import ContentDivider from "../components/atoms/ContentDivider"
import ContentQuestions from "../components/atoms/ContentQuestions"
import Layout from "../components/layout"
import Seo from "../components/seo"
import RelatedContentCards from "../components/organisms/RelatedContentCards"
import BreadCrumbs from "../components/atoms/BreadCrumbs"
import SidebarForm from "../components/atoms/SidebarForm"
import Content from "../components/organisms/Content"

const NewsTemplate = ({ data: { post } }) => {
  const { content, title, keyTakeaways, slug, uri } = post
  const { summary } = keyTakeaways

  let links = [
    { url: "/", name: "Home" },
    { url: "/news", name: "News" },
    { url: slug, name: title },
  ]

  return (
    <Layout sidebar>
      <BreadCrumbs links={links} />
      <IntroSummary 
        {...post}
      />
      <Seo title={title} description={summary} link={uri} />
      <div className="main-content-wrap max-width-wrap">
        <article
          className="blog-post main-content"
          itemScope
          itemType="http://schema.org/Article"
        >
          <section className="articleBody" itemProp="articleBody">
          <ContentSummary {...post} />
          {content && (
            <section>
              <ContentDivider />
              <Content content={content}/>
            </section>
          )}
          </section>  
          <ContentDivider />
          <ContentQuestions {...post} />
        </article>
        <Sidebar>
          <RelatedContentCards type="posts" {...post} />
          <SidebarForm />
        </Sidebar>
      </div>
    </Layout>
  )
}

export default NewsTemplate

export const pageQuery = graphql`
  query BlogPostById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
  ) {
    # selecting the current post by id
    post: wpPost(id: { eq: $id }) {
      id
      content
      title
      uri
      date(formatString: "MMMM DD, YYYY")
      modified(formatString: "MMMM DD, YYYY")
      categories {
        nodes {
          id
          name
          description
          uri
          slug
          resources {
            nodes {
              id
              title
              link
              date(formatString: "MMMM DD, YYYY")
              modified(formatString: "MM-DD-YYYY")
              linkDestination {
                fieldGroupName
                isLinkOnly
                linkDestination
              } 
              categories {
                nodes {
                  name
                }
              }
              taxContentTypes {
                nodes {
                  name
                }
              }
            }
          }
          posts {
            nodes {
              id
              title
              link
              date(formatString: "MMMM DD, YYYY")
              modified(formatString: "MMMM DD, YYYY")
              categories {
                nodes {
                  name
                }
              }
              taxContentTypes {
                nodes {
                  name
                }
              }
            }
          }
          pages {
            nodes {
              id
              title
              link
              date(formatString: "MMMM DD, YYYY")
              modified(formatString: "MMMM DD, YYYY")
              categories {
                nodes {
                  name
                }
              }
              taxContentTypes {
                nodes {
                  name
                }
              }
            }
          }
        }
      }
      taxContentTypes {
        nodes {
          name
        }
      }
      contentOwner {
        contentOwner {
          ... on WpContentTeam {
            id
            title
            slug
            link
            contentTeam {
              whatWeDoPage {
                ... on WpPage {
                  id
                  link
                }
              }
            }
          }
        }
      }
      relatedContentOverride {
        relatedContentField {
          relatedContentItems{
            ... on WpResource {
              id
              title
              link
              linkDestination {
                fieldGroupName
                isLinkOnly
                linkDestination
              } 
              categories {
                nodes {
                  name
                }
              }
              taxContentTypes {
                nodes {
                  name
                }
              }
            }
            ... on WpPost {
              id
              title
              link
              linkDestination {
                fieldGroupName
                isLinkOnly
                linkDestination
              } 
              categories {
                nodes {
                  name
                }
              }
              taxContentTypes {
                nodes {
                  name
                }
              }
            }
            ... on WpPage {
              id
              title
              link
              categories {
                nodes {
                  name
                }
              }
              taxContentTypes {
                nodes {
                  name
                }
              }
            }
          }
        }
      }
      keyTakeaways {
        keyTakeaways
        summary
      }
      internal {
        content
        description
        ignoreType
        mediaType
      }
      slug
      template {
        templateName
      }
      terms {
        nodes {
          name
        }
      }

      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              fluid(maxWidth: 1000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }
      }
    }

  }
`